const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://ramsden-admin.fly.dev/api/v1";
const urlBase = API_BASE_URL

function getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
}

export async function get(url, params = {}) {
    try {
        const query = new URLSearchParams(params).toString();
        const fullUrl = query ? `${urlBase + url}?${query}` : urlBase + url;

        const res = await fetch(fullUrl, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include"
        });

        if (!res.ok) throw new Error(`GET ${url} failed with status ${res.status}`);
        return await res.json();
    } catch (err) {
        console.error(`[GET] ${url}`, err);
        return null;
    }
}

export async function getBlob(url, params = {}) {
    try {
        const query = new URLSearchParams(params).toString();
        const fullUrl = query ? `${urlBase + url}?${query}` : urlBase + url;

        const res = await fetch(fullUrl, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include"
        });

        if (!res.ok) throw new Error(`GET ${url} failed with status ${res.status}`);
        return await res;
    } catch (err) {
        console.error(`[GET] ${url}`, err);
        return null;
    }
}

export async function post(url, data) {
    try {
        const headers = {
            "Content-Type": "application/json",
            "X-CSRF-Token": getCsrfToken()
        };

        const res = await fetch(urlBase + url, {
            method: "POST",
            headers,
            credentials: "include",
            body: JSON.stringify(data)
        });

        if (!res.ok) throw new Error(`POST ${url} failed with status ${res.status}`);

        return await res.json();
    } catch (err) {
        console.error(`[POST] ${url}`, err);
        return null;
    }
}

export async function postFormData(url, data) {
    try {
        // Only wrap in FormData if it's not already
        const formData = data instanceof FormData
            ? data
            : (() => {
                const fd = new FormData();
                Object.entries(data).forEach(([k, v]) => {
                    fd.append(k, v);
                });
                return fd;
            })();

        const headers = {
            "X-CSRF-Token": getCsrfToken()
            // Do NOT set Content-Type manually
        };

        const res = await fetch(urlBase + url, {
            method: "POST",
            headers,
            credentials: "include",
            body: formData
        });

        if (!res.ok) throw new Error(`POST ${url} failed with status ${res.status}`);
        return await res.json();
    } catch (err) {
        console.error(`[POST FORM DATA] ${url}`, err);
        return null;
    }
}

export async function patchFormData(url, id, data) {
    try {

        const endpoint = id ? urlBase + url + "/" + id : urlBase + url;

        const headers = {
            "X-CSRF-Token": getCsrfToken()
        };

        const res = await fetch(endpoint, {
            method: "PATCH",
            headers,
            credentials: "include",
            body: data
        });

        if (!res.ok) throw new Error(`POST ${url} failed with status ${res.status}`);
        return await res.json();
    } catch (err) {
        console.error(`[POST FORM DATA] ${url}`, err);
        return null;
    }
}

export async function patch(url, id, data) {
    try {
        const endpoint = id ? urlBase + url + "/" + id : urlBase + url;

        const headers = {
            "Content-Type": "application/json",
            "X-CSRF-Token": getCsrfToken()
        };

        const res = await fetch(endpoint, {
            method: "PATCH",
            headers,
            credentials: "include",
            body: JSON.stringify(data)
        });

        if (!res.ok) throw new Error(`PATCH ${url} failed with status ${res.status}`);
        return await res.json();
    } catch (err) {
        console.error(`[PATCH] ${url}`, err);
        return null;
    }
}

export async function destroy(url) {
    try {
        const headers = {
            "X-CSRF-Token": getCsrfToken()
        };

        const res = await fetch(urlBase + url, {
            method: "DELETE",
            headers,
            credentials: "include"
        });

        if (!res.ok) throw new Error(`DELETE ${url} failed with status ${res.status}`);
        return await res.json();
    } catch (err) {
        console.error(`[DELETE] ${url}`, err);
        return null;
    }
}
